// extracted by mini-css-extract-plugin
export default {"dropdownHeader":"MessageCenter__dropdownHeader__yKUjN","dropdownMenu":"MessageCenter__dropdownMenu__oB2EF","emptyInbox":"MessageCenter__emptyInbox__rysrB"};